export default "__VITE_ASSET__CNvcLhmC__"